@charset "UTF-8";

/* src/app/components/v2-get-binders/v2-get-binders.component.scss */
:host {
  display: contents;
}
body.v2-get-binders-open {
  overflow: hidden;
}
.v2-get-binders {
  position: fixed;
  inset: 0;
  height: 100%;
  max-height: 100dvh;
  z-index: 10002;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform-origin: 50% 50%;
  animation: v2-get-binders-enter 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
  background: var(--exme-overlay-atmosphere-background);
}
.v2-get-binders.v2-get-binders--closing {
  pointer-events: none;
  animation: v2-get-binders-exit 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
}
.v2-get-binders main.v2-rpc-scroll {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.v2-get-binders main.v2-rpc-scroll::-webkit-scrollbar {
  display: none;
}
@keyframes v2-get-binders-enter {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes v2-get-binders-exit {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-get-binders {
    animation: none;
  }
  .v2-get-binders.v2-get-binders--closing {
    animation: none;
    opacity: 0;
  }
}
.v2-get-binders .v2-rpc-floating-close {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
body.dark .v2-get-binders .v2-rpc-floating-close {
  background: rgba(22, 28, 36, 0.9);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.28);
}
.v2-get-binders .v2-rpc-title-pill {
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(13, 18, 24, 0.07);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
body.dark .v2-get-binders .v2-rpc-title-pill {
  background: rgba(22, 28, 36, 0.92);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
}
.v2-get-binders .manage-wrapper.v2-req-phys-wrap.v2-gb-wrap .v2-rpc-item {
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(13, 18, 24, 0.07) !important;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
body.dark .v2-get-binders .manage-wrapper.v2-req-phys-wrap.v2-gb-wrap .v2-rpc-item {
  background: rgba(22, 28, 36, 0.7);
  border-color: rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.25);
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap {
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap main.v2-rpc-scroll .v2-gb-inner > * {
  opacity: 0;
  transform: scale(0.9) translateY(-40px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > * {
  opacity: 1;
  transform: scale(1) translateY(0);
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(1) {
  transition-delay: 0.35s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(2) {
  transition-delay: 0.5s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(3) {
  transition-delay: 0.65s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(4) {
  transition-delay: 0.8s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(5) {
  transition-delay: 0.95s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(6) {
  transition-delay: 1.1s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(7) {
  transition-delay: 1.25s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(8) {
  transition-delay: 1.4s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(9) {
  transition-delay: 1.55s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(10) {
  transition-delay: 1.7s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(11) {
  transition-delay: 1.85s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(12) {
  transition-delay: 2s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(13) {
  transition-delay: 2.15s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(14) {
  transition-delay: 2.3s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(15) {
  transition-delay: 2.45s;
}
.manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > *:nth-child(16) {
  transition-delay: 2.6s;
}
@media (prefers-reduced-motion: reduce) {
  .manage-wrapper.v2-req-phys-wrap.v2-gb-wrap main.v2-rpc-scroll .v2-gb-inner > * {
    opacity: 1;
    transform: none;
    transition: opacity 0.2s ease;
  }
  .manage-wrapper.v2-req-phys-wrap.v2-gb-wrap.opened.loaded main.v2-rpc-scroll .v2-gb-inner > * {
    transition-delay: 0s !important;
  }
}
.v2-gb-inner {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.v2-req-phys-wrap .v2-rpc-item > .v2-gb-panel {
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0;
  padding: 0;
}
.v2-req-phys-wrap .v2-rpc-item > .v2-gb-panel.v2-gb-panel--gift-info {
  padding: clamp(1rem, 3vw, 1.25rem);
}
.v2-gb-panel {
  background: var(--ion-color-primary-low);
  border-radius: 18px;
  padding: clamp(1rem, 3vw, 1.25rem);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}
.v2-gb-panel--intro {
  padding: clamp(1rem, 3vw, 1.25rem);
}
.v2-gb-intro-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: clamp(0.5rem, 2.5vw, 1.2rem);
  min-width: 0;
}
.v2-gb-intro-image {
  flex: 0 0 auto;
  width: 140px;
  height: 140px;
}
@media (max-width: 420px) {
  .v2-gb-intro-image {
    width: 120px;
    height: 120px;
  }
}
@media (max-width: 380px) {
  .v2-gb-intro-image {
    width: 100px;
    height: 100px;
  }
}
.v2-gb-image-frame {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
  background: var(--ion-color-primary-low);
  border: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.v2-gb-intro-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.v2-gb-intro-copy {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  gap: 0.45rem;
}
.v2-gb-panel--intro .v2-gb-lead {
  margin: 0;
  font-size: clamp(0.95rem, 3.2vw, 1.05rem);
  font-weight: 600;
  line-height: 1.45;
  color: var(--ion-color-text);
  word-break: break-word;
  overflow-wrap: anywhere;
}
.v2-gb-panel--intro .v2-gb-meta {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.45;
  color: var(--ion-color-text);
}
.v2-gb-panel--qty-fields {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.v2-gb-panel--qty-fields .v2-gb-qty-grid {
  padding-bottom: 0.25rem;
  border-bottom: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
}
.v2-gb-qty-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.6rem;
}
@media (min-width: 400px) {
  .v2-gb-qty-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.v2-gb-qty-grid .btn-wrapper {
  width: 100%;
}
.v2-gb-qty-grid .btn-wrapper .btn {
  min-height: 48px;
  width: 100%;
  border-radius: 14px;
  font-weight: 700;
}
.v2-gb-panel--qty-fields .v2-gb-field-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  align-items: stretch;
}
@media (max-width: 380px) {
  .v2-gb-panel--qty-fields .v2-gb-field-grid {
    grid-template-columns: 1fr;
  }
}
.v2-gb-panel--qty-fields .v2-gb-range-hint {
  margin-top: 0;
}
.v2-gb-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--ion-color-text);
  margin-bottom: 0.35rem;
}
.v2-gb-input {
  width: 100%;
  box-sizing: border-box;
  min-height: 48px;
  padding: 0.65rem 0.85rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--ion-color-text);
  background: var(--ion-color-background);
  border: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.12));
  border-radius: 12px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.v2-gb-input:focus {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.2);
}
.v2-gb-input--tel {
  font-variant-numeric: tabular-nums;
}
.v2-gb-readonly {
  min-height: 48px;
  padding: 0.65rem 0.85rem;
  font-size: 1rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--ion-color-primary);
  background: var(--ion-color-background);
  border: 1px dashed var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
  border-radius: 12px;
  display: flex;
  align-items: center;
}
.v2-gb-range-hint {
  margin: 0;
  padding: 0 0.25rem;
  font-size: 0.82rem;
  line-height: 1.4;
  color: var(--ion-color-red);
}
.v2-gb-range-hint--ok {
  color: var(--ion-color-primary);
}
.v2-gb-panel--payment {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
}
.v2-gb-pay-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.1));
  border-radius: 14px;
  background: var(--ion-color-background);
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: var(--ion-color-text);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.v2-gb-pay-row:hover {
  border-color: var(--ion-color-primary-tint);
}
.v2-gb-pay-row--active {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 2px rgba(var(--ion-color-primary-rgb), 0.2);
}
.v2-gb-pay-radio {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid var(--ion-color-text);
  flex-shrink: 0;
  position: relative;
}
.v2-gb-pay-row--active .v2-gb-pay-radio {
  border-color: var(--ion-color-primary);
}
.v2-gb-pay-row--active .v2-gb-pay-radio::after {
  content: "";
  position: absolute;
  inset: 3px;
  border-radius: 50%;
  background: var(--ion-color-primary);
}
.v2-gb-pay-label {
  flex: 1;
  font-weight: 600;
  font-size: 0.95rem;
}
.v2-gb-pay-logo {
  width: 3.25rem;
  height: auto;
  object-fit: contain;
}
.v2-gb-card-icon {
  font-size: 1.75rem;
  color: var(--ion-color-primary);
  flex-shrink: 0;
}
.v2-gb-check {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-top: 0.75rem;
  font-size: 0.88rem;
  line-height: 1.4;
  color: var(--ion-color-text);
  cursor: pointer;
}
.v2-gb-check input[type=checkbox] {
  width: 1.15rem;
  height: 1.15rem;
  margin-top: 0.1rem;
  accent-color: var(--ion-color-primary);
  flex-shrink: 0;
}
.v2-gb-panel--note .v2-gb-note {
  margin: 0;
  text-align: center;
  font-size: 0.9rem;
  line-height: 1.45;
  color: var(--ion-color-text);
}
.v2-gb-panel--invoice .v2-gb-check--invoice-toggle {
  margin-top: 0;
}
.v2-gb-invoice-expand {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin-top: 0.75rem;
  padding-top: 0.9rem;
  border-top: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
}
.v2-gb-invoice-expand .v2-gb-invoice-note {
  margin: 0;
  text-align: center;
  font-size: 0.85rem;
  color: var(--ion-color-text);
  padding: 0;
}
.v2-gb-invoice-expand .v2-gb-check {
  margin-top: 0;
}
.v2-gb-submit {
  width: 100%;
  margin-top: 0.25rem;
}
.v2-gb-submit .btn-wrapper {
  width: 100%;
}
.v2-gb-submit .btn-wrapper .btn {
  min-height: 52px;
  width: 100%;
  border-radius: 14px;
  font-weight: 700;
}
.v2-get-binders > .loader-parent {
  position: absolute;
  inset: 0;
  z-index: 80;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.4s ease;
}
.v2-get-binders > .loader-parent > .loader {
  width: 100px;
  height: 100px;
  max-width: 100px;
  max-height: 100px;
  flex-shrink: 0;
  overflow: hidden;
  box-sizing: border-box;
}
.v2-get-binders > .loader-parent > .loader svg {
  width: 100% !important;
  height: 100% !important;
  display: block;
}
body.dark .v2-gb-input,
body.dark .v2-gb-readonly {
  background: var(--ion-color-step-50, #1e1e1e);
}
.v2-gb-inner--gift {
  margin-top: 0.5rem;
}
.v2-gb-gift-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  width: 100%;
}
.v2-gb-gift-copy {
  width: 100%;
  max-width: 28rem;
  margin-inline: auto;
  min-width: 0;
}
.v2-gb-gift-message {
  margin: 0;
  font-size: 1rem;
  line-height: 1.55;
  color: var(--ion-color-text);
  text-align: center;
}
/*# sourceMappingURL=v2-get-binders.component.css.map */
